import * as Yup from 'yup';

export const CreateLoginValidationSchema = Yup.object().shape({
    username: Yup.string()
        .required('Username is required')
        .min(3, 'Username must be at least 3 characters long')
        .max(20, 'Username must be less than 20 characters'),
    email: Yup.string()
        .email('Invalid email format')
        .matches(/.[!@#$%^&(),.?":{}|<>].*/, 'Email must contain at least one special character')
        .required('Email is required'),
    password: Yup.string()
        .min(8, 'Password must be at least 8 characters long')
        .max(20, 'Password must be less than 20 characters long')
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
        .matches(/\d/, 'Password must contain at least one number')
        .matches(/[@#]/, 'Password must contain at least one special character'),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .required('Confirm Password is required'),
})